import { Controller } from "@hotwired/stimulus"

const PRESET_SCHEME_IDLE = "btn-secondary"
const PRESET_SCHEME_ACTIVE = "btn-primary"

function setsEqual(a, b) {
  if (a.size !== b.size) return false
  for (const v of a) {
    if (!b.has(v)) return false
  }
  return true
}

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { presets: Object }

  connect() {
    this.syncScopeBadges()
    this.syncActivePresetFromSelection()
  }

  applyPreset(event) {
    const key = event.currentTarget.dataset.presetKey
    const selected = new Set(this.presetsValue[key] || [])
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = selected.has(checkbox.value)
    })
    this.syncScopeBadges()
    this.setActivePresetTab(event.currentTarget)
  }

  setActivePresetTab(activeButton) {
    this.element.querySelectorAll('[data-preset-tab]').forEach((btn) => {
      btn.classList.remove(PRESET_SCHEME_ACTIVE)
      btn.classList.add(PRESET_SCHEME_IDLE)
    })
    activeButton.classList.remove(PRESET_SCHEME_IDLE)
    activeButton.classList.add(PRESET_SCHEME_ACTIVE)
  }

  clearPresetTabHighlight() {
    this.element.querySelectorAll('[data-preset-tab]').forEach((btn) => {
      btn.classList.remove(PRESET_SCHEME_ACTIVE)
      btn.classList.add(PRESET_SCHEME_IDLE)
    })
  }

  syncActivePresetFromSelection() {
    const selected = new Set(
      this.checkboxTargets.filter((c) => c.checked).map((c) => c.value)
    )
    let matched = null
    this.element.querySelectorAll('[data-preset-tab]').forEach((btn) => {
      const key = btn.dataset.presetKey
      const preset = new Set(this.presetsValue[key] || [])
      if (setsEqual(selected, preset)) matched = btn
    })
    if (matched) {
      this.setActivePresetTab(matched)
    } else {
      this.clearPresetTabHighlight()
    }
  }

  selectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
    this.syncScopeBadges()
    this.syncActivePresetFromSelection()
  }

  clearSelection() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.syncScopeBadges()
    this.syncActivePresetFromSelection()
  }

  syncScopeBadges() {
    this.checkboxTargets.forEach((checkbox) => {
      const row = checkbox.closest("[data-scopes-row]")
      if (!row) return
      const checked = checkbox.checked

      const pending = row.querySelector("[data-scopes-pending-badge]")
      if (pending) pending.classList.toggle("hidden", !checked)

      const grantedBadge = row.querySelector("[data-scopes-granted-badge]")
      const removesBadge = row.querySelector("[data-scopes-removes-badge]")
      if (grantedBadge && removesBadge) {
        grantedBadge.classList.toggle("hidden", !checked)
        removesBadge.classList.toggle("hidden", checked)
      }
    })
  }
}
